<script lang="ts" setup>
import { Avatar } from "@frontiers-vue3/public-pages";
import type { ITopicEditorProps } from "./TopicEditor.models";

const props = defineProps<{
  editor: ITopicEditorProps;
}>();

const { loopUrl } = useRuntimeConfig().public;

const getEditorImage = () => {
  const hasId = props.editor.loopUserId > 0;
  return hasId ? `${loopUrl}/images/profile/${props.editor.loopUserId}/74` : "";
};

const loopProfileUrl = `${loopUrl}/people/${props.editor.loopUserId}`;
</script>

<template>
  <a
    class="TopicEditor"
    :href="loopProfileUrl"
    target="_blank">
    <Avatar
      :full-name="editor.fullName"
      :src="getEditorImage()"
      color="Grey"
      size="Size40" />
    <div class="TopicEditor__info">
      <p class="TopicEditor__info__name">{{ editor.fullName }}</p>
      <p class="TopicEditor__info__more">{{ editor.organizationName }}</p>
      <p class="TopicEditor__info__more">{{ editor.organizationLocation }}</p>
    </div>
  </a>
</template>

<style lang="scss">
.TopicEditor {
  display: flex;
  gap: spacing(2);
  min-width: 0;

  &__info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    flex: 1;

    &__name {
      @include f("heading-xs-bold");
      color: $textPrimary;
      @include ellipsis;
    }

    &__more {
      @include f-14-300;
      color: $textTertiary;
      @include ellipsis;
    }
  }
}
</style>
